import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { CustomFormApiParameter, CustomFormModel, submit,KeyValue } from "@nishtech/Services/CustomFormsGenericService";
export interface CustomFormParameter {
    recepientEmails:string;
    formType:string;
    emailTemplate:string,
    values:KeyValue;
    onSuccess?: () => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandlerDiscreteParameter<CustomFormParameter, CustomFormApiParameter, ServiceResult<CustomFormModel>>;

export const PopulateApiParameter: HandlerType = props => {
    const customformModel = {
        recepientEmails: props.parameter.recepientEmails,
        formType:props.parameter.formType,
        emailTemplate:props.parameter.emailTemplate,
        values:props.parameter.values
    } as CustomFormModel;
    props.apiParameter = { customformModel };
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await submit(props.apiParameter);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.();
    }
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback,ExecuteOnErrorCallback];

const SubmitGenericForm = createHandlerChainRunner(chain, "SubmitGenericForm");
export default SubmitGenericForm;
